import {
  Box,
  Container,
  Divider,
  SimpleGrid,
  VStack,
  HStack,
  Text,
  Link,
  Image,
  useColorMode
} from "@chakra-ui/react"
import { Link as RouterLink, useNavigate } from "react-router-dom"
import { Logo } from "../../../Logo"
// import { links } from './_data'
import { useAuth } from "../../../contexts/AuthContext";
import { CartPreview } from "../../../pages/products/components/CartPreview";
import { getColor, brandConfig, getComponent } from "../../../brandConfig";






export const FooterWithFourColumns = () => {
  const { user, isAuthenticated } = useAuth();
  const { colorMode } = useColorMode();
  const navigate = useNavigate();

  // Detailed console logging of user data
  // console.log('🦶 Footer Auth State:', {
  //   isAuthenticated,
  //   userData: {
  //     id: user?.id,
  //     name: `${user?.fName} ${user?.lName}`,
  //     email: user?.email,
  //     role: user?.role,
  //     permissions: user?.permissions,
  //     isVerifiedSeller: user?.isVerifiedSeller,
  //     businessDetails: {
  //       name: user?.businessName,
  //       registrationNumber: user?.businessRegistrationNumber
  //     },
  //     addresses: {
  //       shipping: user?.shippingAddresses,
  //       billing: user?.billingAddresses
  //     },
  //     paymentDetails: user?.paymentReceivingDetails,
  //     documents: {
  //       signature: user?.encryptedSignatureIpfsUrl
  //     },
  //     dates: {
  //       created: user?.createdAt,
  //       updated: user?.updatedAt
  //     },
  //     tenantId: user?.tenantId
  //   }
  // });

  const links = [
    {
      // title: 'Company',
      links: [

        // { label: 'New Website', href: '/newwebsite' },
        // { label: 'Websites', href: '/websites' },
        // { label: 'Services', href: '/services' },
        // { label: 'New Service', href: '/services/new' },
        // { label: "Governance", href: "/governance" },


        // ...(isAuthenticated && user?.permissions?.includes('SELLER') ? [{ label: 'Add Product', href: '/products/new' }] : []),
        // Add membership agreement link if signature exists
        ...(user?.encryptedSignatureIpfsUrl ? [
          {
            label: "My Signed Membership Agreement",
            href: `/membership-certificate/${user.id}`
          }
        ] : []),
        // { label: 'Careers', href: '#' },
        // { label: 'Press', href: '#' },
        // { label: 'FAQs', href: '/earn' },
      ],
    },
    {
      title: "Resources",
      links: [
        // { label: "Blog", href: "/blog" },
        // ...(isAuthenticated ? [{ label: "News", href: "/news" }] : []),
        // ...(isAuthenticated ? [{ label: 'SATS=>AUD', href: 'https://coincodex.com/convert/satoshi-sats/aud/1000/' }] : []),
        // { label: 'Case studies', href: '#' },
        // { label: 'Media Assets', href: '#' },
      ],
    },
    {
      title: "Admin",
      links: [
        ...(user?.permissions?.includes("admin") ? [{ label: "All Users (admin)", href: "/allusers" }] : []),
        ...(user?.permissions?.includes("admin") ? [{ label: "All Purchases (admin)", href: "/alluserspurchases" }] : []),
        // ...(user?.permissions?.includes("admin") ? [{ label: "Node Info (admin)", href: "/nodeinfo" }] : []),
        // ...(user?.permissions?.includes('admin') ? [{ label: 'BTCPay Invoices', href: '/btcpayinvoices' }] : []),
        // ...(user?.permissions?.includes('admin') ? [{ label: 'All Orders', href: '/allorders' }] : []),
        ...(user?.permissions?.includes("admin") ? [{ label: "3 Day Challenge", href: "/3daychallenge" }] : []),
        ...(user?.permissions?.includes("admin") ? [{ label: "1 Lead Magnet", href: "/leadmagnet" }] : []),
        ...(user?.permissions?.includes("admin") ? [{ label: "2 Webinar Invite", href: "/relationships/free-event" }] : []),
        ...(user?.permissions?.includes("admin") ? [{ label: "3 Sales Page", href: "/courses/relationships/start" }] : []),
        // ...(user?.permissions?.includes('admin') ? [{ label: '2 Webinar Sales Page', href: '/relationships/free-event' }] : []),
        // ...(user?.permissions?.includes('admin') ? [{ label: 'Relationship Registrations', href: '/admin/relationshipcourseregistrations' }] : []),
        // { label: 'Privacy Policy', href: '#' },
        // { label: 'Offer terms', href: '#' },
        // { label: 'License', href: '#' },
        // { label: "About", href: "/founders" },
      ],
    },
  ]

  // Debug log for links visibility
  // console.log('🔗 Footer Links State:', {
  //   isAuthenticated,
  //   userPermissions: user?.permissions,
  //   visibleLinks: links.map(group => ({
  //     title: group.title,
  //     links: group.links.map(link => link.label)
  //   }))
  // });

  // Debug log to verify signature URL condition
  // console.log('📜 Membership Agreement State:', {
  //   hasSignature: !!user?.encryptedSignatureIpfsUrl,
  //   signatureUrl: user?.encryptedSignatureIpfsUrl,
  //   userId: user?.id,
  //   membershipLink: user?.encryptedSignatureIpfsUrl ? `/membership-certificate/${user.id}` : null
  // });

  return (<>
    <Box
      bg="#EBEBEB"
      borderTop="1px solid"
      borderColor="rgba(3, 23, 122, 0.1)"
      pt={{ base: 6, md: 6 }}
      pb={{ base: 6, md: 8 }}
      mt="auto"
      position="relative"
      zIndex={10}
    >
      <Container as="footer" role="contentinfo" maxW="100%" pl={{ base: "5vw", md: "5vw", lg: "5vw" }} pr={{ base: "5vw", md: "5vw", lg: "5vw" }}>
        <HStack
          width="full"
          justify="space-between"
          align="start"
          flexDirection={{ base: "column", lg: "row" }}
          gap={{ base: 8, lg: 0 }}
        >
          {/* Brand Section - Logo Image */}
          <Box ml={{ base: "15px", lg: "35px" }}>
            <VStack align="center" spacing={6}>
              <Image
                src="/logo/VC_Stack Logo.png"
                alt="Vanguard Care Logo"
                height={{ base: "120px", lg: "160px" }}
                objectFit="contain"
              />
            </VStack>
            <Text
              fontSize="md"
              color="rgba(3, 23, 122, 0.6)"
              maxW="280px"
              lineHeight="1.6"
              textAlign="center"
              mt={4}
            >
              {brandConfig.description}
            </Text>
          </Box>

          {/* Three columns container */}
          <HStack
            align="start"
            gap={{ base: 8, lg: "120px", xl: "200px" }}
            mr={{ base: "15px", lg: "35px" }}
            flexDirection={{ base: "column", lg: "row" }}
            mt={{ base: 0, lg: "60px" }}
            flexShrink={0}
          >
            {/* Quick Links */}
            <VStack align="start" spacing={0} minW={{ lg: "100px" }}>
            <Text fontSize="lg" fontWeight="600" color="#03177A" height={{ base: "auto", lg: "auto" }} display="flex" alignItems="center" whiteSpace="nowrap">
              Quick Links
            </Text>
            <VStack align="start" spacing={3} mt={6}>
              <Link
                as={RouterLink}
                to="/"
                color="rgba(3, 23, 122, 0.6)"
                fontSize="md"
                fontWeight="400"
                transition="all 0.2s ease"
                cursor="pointer"
                onClick={() => {
                  navigate("/");
                  window.scrollTo(0, 0);
                  document.body.scrollTop = 0;
                }}
                _hover={{
                  color: "#FF6600",
                  textDecoration: "none"
                }}
              >
                Home
              </Link>
              <Link
                as={RouterLink}
                to="/about-us"
                color="rgba(3, 23, 122, 0.6)"
                fontSize="md"
                fontWeight="400"
                transition="all 0.2s ease"
                cursor="pointer"
                onClick={() => {
                  navigate("/about-us");
                  window.scrollTo(0, 0);
                  document.body.scrollTop = 0;
                }}
                _hover={{
                  color: "#FF6600",
                  textDecoration: "none"
                }}
              >
                About
              </Link>
              <Link
                as={RouterLink}
                to="/corporate-services"
                color="rgba(3, 23, 122, 0.6)"
                fontSize="md"
                fontWeight="400"
                transition="all 0.2s ease"
                cursor="pointer"
                onClick={() => {
                  navigate("/corporate-services");
                  window.scrollTo(0, 0);
                  document.body.scrollTop = 0;
                }}
                _hover={{
                  color: "#FF6600",
                  textDecoration: "none"
                }}
              >
                Our Services
              </Link>
              <Link
                as={RouterLink}
                to="/our-facilities"
                color="rgba(3, 23, 122, 0.6)"
                fontSize="md"
                fontWeight="400"
                transition="all 0.2s ease"
                cursor="pointer"
                onClick={() => {
                  navigate("/our-facilities");
                  window.scrollTo(0, 0);
                  document.body.scrollTop = 0;
                }}
                _hover={{
                  color: "#FF6600",
                  textDecoration: "none"
                }}
              >
                Our Facilities
              </Link>
              <Link
                as={RouterLink}
                to="/contact-us"
                color="rgba(3, 23, 122, 0.6)"
                fontSize="md"
                fontWeight="400"
                transition="all 0.2s ease"
                cursor="pointer"
                onClick={() => {
                  navigate("/contact-us");
                  window.scrollTo(0, 0);
                  document.body.scrollTop = 0;
                }}
                _hover={{
                  color: "#FF6600",
                  textDecoration: "none"
                }}
              >
                Contact Us
              </Link>
            </VStack>
          </VStack>

          {/* Contact Information */}
          <VStack align="start" spacing={0} minW={{ lg: "140px" }}>
            <Text fontSize="lg" fontWeight="600" color="#03177A" height={{ base: "auto", lg: "auto" }} display="flex" alignItems="center" whiteSpace="nowrap">
              For all enquiries, contact:
            </Text>
            <VStack align="start" spacing={3} mt={6}>
              <Text
                color="rgba(3, 23, 122, 0.6)"
                fontSize="md"
                fontWeight="400"
              >
                {brandConfig.contact.email}
              </Text>
              <Text
                color="rgba(3, 23, 122, 0.6)"
                fontSize="md"
                fontWeight="400"
              >
                {brandConfig.contact.phone}
              </Text>
            </VStack>
          </VStack>

          {/* Company Information */}
          <VStack align="start" spacing={0} minW={{ lg: "120px" }}>
            <Text fontSize="lg" fontWeight="600" color="#03177A" height={{ base: "auto", lg: "auto" }} display="flex" alignItems="center" whiteSpace="nowrap">
              {brandConfig.contact.businessName}
            </Text>
            <VStack align="start" spacing={2} mt={6}>
              <Text fontSize="md" color="rgba(3, 23, 122, 0.6)">
                ACN 61200592
              </Text>
              <Text fontSize="md" color="rgba(3, 23, 122, 0.6)">
                AFSL 487419
              </Text>
            </VStack>
          </VStack>
          </HStack>
        </HStack>

        {/* Bottom Copyright Bar */}
        <Box mt={{ base: 4, lg: 6 }} pt={3} borderTop="1px solid" borderColor="rgba(3, 23, 122, 0.15)">
          <Container maxW="100%" px={0}>
            <HStack justify="space-between" w="full" flexWrap="wrap" spacing={4} align="center">
              <HStack spacing={4} flexWrap="wrap">
                <Link
                  href="/Privacy Policy - 08.01.2026.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  fontSize="xs"
                  color="rgba(3, 23, 122, 0.5)"
                  transition="all 0.2s ease"
                  _hover={{
                    color: "#FF6600",
                    textDecoration: "none"
                  }}
                >
                  Privacy Policy
                </Link>
                <Text fontSize="xs" color="rgba(3, 23, 122, 0.4)">
                  •
                </Text>
                <Text fontSize="xs" color="rgba(3, 23, 122, 0.5)">
                  © {new Date().getFullYear()} {brandConfig.siteName}. All rights reserved.
                </Text>
              </HStack>

              <Text fontSize="xs" color="rgba(3, 23, 122, 0.5)">
                Website Designed by Summer Digital Agency
              </Text>
            </HStack>
          </Container>
        </Box>
      </Container>
    </Box>

    <Box
      position="fixed"
      bottom={4}
      right={4}
      zIndex={5}
    >
      <CartPreview />
    </Box>
  </>
  )
}